import apiClient from '../client';

export interface TreatmentStep {
  id: number;
  create_by: string;
  update_by: string;
  title: string;
  description: string;
  start_date: string | null;
  end_date: string | null;
  audio: string | null;
  media: string | null;
  treatment: number;
  step_num: number;
  note: string;
  folder: string | null;
  complete: boolean;
  base_step: number | null;
  doctor: number;
  status: string | null;
  flag_if_missed: boolean;
  time_specificity: string | null;
  relative_to_step: number | null;
  relative_to_date: string | null;
  offset_amount: number | null;
  offset_units: string | null;
  relative_direction: string | null;
  urgency: string | null;
  tags: string[];
}

export interface TreatmentPlan {
  id: number;
  create_by?: string;
  update_by?: string;
  name: string;
  description: string;
  folder: string | null;
  patient: number | null;
  doctor?: number;
  base_treatment: number | null;
  tags?: string[];
  completion?: string;
  completed_steps?: number;
  total_steps?: number;
  status: string | null;
  flagged?: boolean;
  paused?: boolean;
  last_activity_date: string | null;
  steps?: TreatmentStep[];
  is_draft?: boolean;
  is_sent?: boolean;
  sent_from_treatment?: number | null;
}

export interface PatientAnalyticsData {
  patient_id: number;
  patient_name: string;
  patient_status: boolean;
  email: string;
  phone: string;
  dob: string;
  medicare: number;
  last_activity_date: string;
  treatment_plans: TreatmentPlan[];
}

export interface AnalyticsMetrics {
  current_month: string;
  previous_month: string;
  active_patients: number;
  current_month_patients_on_treatment: number;
  prev_month_patients_on_treatment: number;
  patient_increase: number;
  patient_increase_percentage: number;
  current_adherence_rate: number;
  prev_adherence_rate: number;
  adherence_increase: number;
  missed_treatments_count: number;
  missed_treatments: TreatmentPlan[];
  missed_treatments_today_count: number;
}

export interface PatientAnalytics {
  patient_data: PatientAnalyticsData[];
  analytics: AnalyticsMetrics;
}

export interface PatientAnalyticsResponse {
  message?: string;
  data: PatientAnalytics;
}

export const AnalyticsApi = {
  /**
   * Get patient analytics data
   * @returns Patient analytics data including patient data and metrics
   */
  getPatientAnalytics: async (): Promise<PatientAnalyticsResponse> => {
    const response = await apiClient.get('/patients/analytics/');
    return response;
  },
};
